// 筛选输出具有相同 label 的数组对象
const filterSameLabelObjects = (arr1, arr2) => {
  const sortedList1 = arr2.map(item => {
    const items = arr1.find(obj => obj.label === item.label)
    return items ? { ...items, visible: item.visible } : undefined
  })
  return sortedList1.filter(item => item) || []
}

export const setColumns = (columns = [], list) => {
  if (!list) return columns
  if (columns.length && list && list.length) {
    // 从 list 中筛选出与 columns 中的 label 匹配的元素（保持用户已保存的顺序与显隐）
    const matchedItems = filterSameLabelObjects(columns, list) || []
    // 从 columns 中筛选出未匹配的元素（即后新增的列）
    const unmatchedItems =
      columns?.filter(
        item => !list.some(mapItem => mapItem.label === item.label)
      ) || []
    // 操作列固定在最后
    const endList = matchedItems[matchedItems.length - 1]
    const isEndAction =
      endList && (endList.prop === 'action' || endList.label === '操作')
    if (isEndAction) {
      matchedItems.pop()
    }
    // 新列按代码中的相对位置插入到已保存的列序中
    unmatchedItems.forEach(un => {
      const idx = columns.indexOf(un)
      let insertAt = -1
      for (let i = idx - 1; i >= 0; i--) {
        const pos = matchedItems.findIndex(
          m => m.label === columns[i].label
        )
        if (pos > -1) {
          insertAt = pos + 1
          break
        }
      }
      if (insertAt === -1) {
        for (let i = idx + 1; i < columns.length; i++) {
          const pos = matchedItems.findIndex(
            m => m.label === columns[i].label
          )
          if (pos > -1) {
            insertAt = pos
            break
          }
        }
      }
      if (insertAt === -1) insertAt = matchedItems.length
      matchedItems.splice(insertAt, 0, un)
    })
    if (isEndAction) {
      matchedItems.push(endList)
    }
    return matchedItems || columns
  }
  return columns
}
